import * as React from 'react';

import { Promo, Socket } from '../../components/ActionButton';
import { EActionButtonType, TActionButtonV2 } from '../../types/actionButton';
import { TActionButtonV3 } from '../../types/actionButtonV3';
import { useActionButtonHandler } from './useActionButtonHandler';
import { DemandActionContainer } from '../DemandActionContainer';
import { EIconPosition, EStyle } from '../../repositories/chats/entities/action_button_v3/ActionButtonV3Schema';
import { Image } from '@cian/ui-kit';
import { ActionButton } from '../../components/ActionButton/ActionButton';

type TActionButton = TActionButtonV2 | TActionButtonV3;

type TActionButtonContainerProps = {
  actionButton: TActionButton;
  messageId: string;
  communicationId?: string;
  index?: number;
  isOutcoming?: boolean;
};

const DEMAND_TRAP_LINK = 'homeownerLeadCreateMessage';

export const ActionButtonContainer: React.FC<TActionButtonContainerProps> = ({
  actionButton,
  messageId,
  communicationId,
  index,
  isOutcoming,
}) => {
  const { link, type, text } = actionButton;

  const аctionButtonHandler = useActionButtonHandler(actionButton, messageId, communicationId);

  //блок для кнопок типа TActionButtonV3
  if ('style' in actionButton) {
    if (actionButton.style === EStyle.ButtonPrimary || actionButton.style === EStyle.ButtonSecondary) {
      return (
        <ActionButton
          key={`chatbot-action-button-${index}`}
          theme={
            isOutcoming
              ? 'fill_white_primary'
              : actionButton.style === EStyle.ButtonPrimary
                ? 'fill_primary'
                : 'fill_secondary'
          }
          beforeIcon={
            actionButton.icon && actionButton.iconPosition === EIconPosition.Start ? (
              <Image
                src={actionButton.icon}
                width={16}
                height={16}
                preloader={false}
                borderRadius="0"
                data-name="actionButton_image_start"
              />
            ) : undefined
          }
          afterIcon={
            actionButton.icon && actionButton.iconPosition === EIconPosition.End ? (
              <Image
                src={actionButton.icon}
                width={16}
                height={16}
                preloader={false}
                borderRadius="0"
                data-name="actionButton_image_end"
              />
            ) : undefined
          }
          actionButtonHandle={аctionButtonHandler}
        >
          {text}
        </ActionButton>
      );
    }

    if (actionButton.style === EStyle.Link) {
      return (
        <Promo
          link={link as string}
          text={text}
          onClick={аctionButtonHandler}
          icon={actionButton.icon}
          iconPosition={actionButton.iconPosition}
          gravity={actionButton.gravity}
          isOutcoming={isOutcoming}
          index={index}
        />
      );
    }
  }

  if (link === DEMAND_TRAP_LINK) {
    return <DemandActionContainer actionButton={actionButton} />;
  }

  if (type === EActionButtonType.Socket) {
    return <Socket text={text} onClick={аctionButtonHandler} />;
  }

  if (link) {
    return <Promo link={link as string} text={text} onClick={аctionButtonHandler} />;
  }

  return null;
};
